module.exports = __webpack_public_path__ + "img/04—02—Phonebook > IB Standard.71229e37.jpg";